import React from "react"
import { Button } from "@/components/ui/button"
import { ClipboardList, RefreshCcw, CheckCircle, X, ChevronUp, ChevronDown, MoreVertical } from "lucide-react"

export default function Header({ itemName, lpo, shelf }: { itemName: string; lpo: string; shelf: string }) {
  return (
    <div className="px-2">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-1">
          <Button variant="ghost" size="icon" className="h-7 w-7">
            <X className="h-4 w-4" />
          </Button>
          <Button variant="outline" size="sm" className="px-2 h-7">
            <ChevronUp className="h-4 w-4" />
          </Button>
          <Button variant="outline" size="sm" className="px-2 h-7">
            <ChevronDown className="h-4 w-4" />
          </Button>
          <div className="text-base font-semibold ml-2">{itemName}</div>
        </div>
        <Button variant="ghost" size="icon" className="h-7 w-7">
          <MoreVertical className="h-4 w-4" />
        </Button>
      </div>
      <hr className="my-2" />
      <div className="flex items-center justify-between">
        <div className="text-sm text-muted-foreground flex items-center">
          <span className="mr-2">{lpo}</span>
          <span className="mx-2">|</span>
          <a href="#" className="text-muted-foreground">{shelf}</a>
        </div>
        <div className="flex items-center gap-2">
          <Button variant="outline" size="xs">
            <ClipboardList className="h-3.5 w-3.5 mr-1" />
            Create Requisition
          </Button>
          <Button variant="outline" size="xs">
            <RefreshCcw className="h-3.5 w-3.5 mr-1" />
            Request Stock
          </Button>
          <Button variant="outline" size="xs">
            <CheckCircle className="h-3.5 w-3.5 mr-1" />
            Update Status
          </Button>
        </div>
      </div>
      <hr className="my-2" />
    </div>
  )
}

